<template>
  <div
    :class="`filter_box ${showFilterBox ? 'show' : ''}`"
    :style="`top: ${filterBoxPosition.top}px; left: ${filterBoxPosition.left}px;`"
    @mouseover="() => (onHoverFilterBox = true)"
    @mouseleave="() => (onHoverFilterBox = false)"
  >
    <div class="filter_box__content">
      <span class="filter_box__content__text" v-if="countLoading"><Loading :width="40" color="#217899" /></span>
      <span class="filter_box__content__text" v-else>Предложений: {{count}}</span>
      <v-btn color="#217899" style="color: white;" @click="showFunc">Показать</v-btn>
    </div>
  </div>
</template>
<script>
import Loading from './loading.vue'
export default {
  name: "calc_filter_message_box",
  components: {Loading},
  data: () => ({
    onHoverFilterBox: false,
  }),
  methods: {},
  computed: {
    showFilterBox: {
      get(){return this.$store.getters.getShowFilterBox},
      set(val){this.$store.commit('SET_SHOW_FILTER_BOX',val)}
    },
    filterBoxPosition: {
      get(){return this.$store.getters.getFilterBoxPosition},
      set(val){this.$store.commit('SET_FILTER_POSITION',val)}
    },
    count: {
      get(){return this.$store.getters.getFilterCount},
    },
    showFunc: {
      get(){return this.$store.getters.getFilterShowFunc},
    },
    countLoading: {
      get(){return this.$store.getters.getFilterCountLoading},
    }
  },
  mounted() {},
  watch: {
    showFilterBox(val) {
      if (val === true && this.onHoverFilterBox === false) {
        setTimeout(() => {
          if (!this.onHoverFilterBox) {
            this.showFilterBox = false;
          }
        }, 5000);
      }
    },
    onHoverFilterBox(val){
      if(val === false){
        setTimeout(() => {
            this.showFilterBox = false;
        }, 5000);
      }
    }
  },
};
</script>
<style lang="sass" scoped>
.filter_box
  position: fixed
  width: 145px
  background-color: white
  z-index: 99999999
  box-shadow: 0px 0px 20px 5px rgba(0,0,0 , .3)
  border-radius: 10px
  padding: 10px
  transition: all .3s linear
  opacity: 0
  pointer-events: none
  &.show
    opacity: 1
    pointer-events: all
  &::before
    position: absolute
    content: ''
    border: 20px solid transparent
    border-right: 20px solid white
    left: -39px
    top: 36px
  .filter_box__content
    display: flex
    flex-wrap: wrap
    justify-content: center
    row-gap: 10px
    &__text
      text-align: center
</style>
